import React, { Suspense, lazy } from 'react';
import { Spin } from 'antd';
// Yeap Site Builder — customer console pages (routes in user/UserApp.js: /sites, /sites/:id/*, /sites/:id/editor/:pageId?)
export { default as SitesList } from './SitesList';
export { default as SiteLayout } from './SiteLayout';
export { default as SiteOverview } from './Overview';
export { default as SitePages } from './Pages';
export { default as SiteDomains } from './Domains';
export { default as SiteForms } from './Forms';
export { default as SiteContent } from './Content';
export { default as SiteBookings } from './Bookings';
export { default as SiteMedia } from './Media';
export { default as SiteMarketing } from './Marketing';
export { default as SiteStaff } from './ShopStaff';
export { default as SiteGiftCards } from './ShopGiftCards';
export { default as SiteReviews } from './ShopReviews';
export { default as SiteInventory } from './ShopInventory';
export { default as SiteDraftOrders } from './ShopDraftOrders';
export { default as SiteAbandoned } from './ShopAbandoned';
export { default as SiteSettings } from './Settings';
export { default as SiteVersions } from './Versions';
export { default as SiteProducts } from './Products';
export { default as SiteProductEdit } from './ProductEdit';
export { default as SiteProductsBulk } from './ProductsBulk';
export { default as SiteAnalytics } from './Analytics';
export { default as SiteCollections } from './Collections';
export { default as SiteCollectionEdit } from './CollectionEdit';
export { default as SiteOrders } from './Orders';
export { default as SiteOrderDetail } from './OrderDetail';
export { default as SiteReturns } from './Returns';
export { default as SiteCustomers } from './Customers';
export { default as SiteCustomerDetail } from './CustomerDetail';
export { default as SiteDiscounts } from './Discounts';
export { default as SitePayments } from './Payments';
export { default as SiteBlog } from './Blog';
export { default as SitePostEdit } from './PostEdit';
export { default as SiteComments } from './Comments';
export { BlogTerms as SiteBlogTerms, BlogAuthors as SiteBlogAuthors } from './BlogTaxonomy';

// The editor (LiquidJS engine, preview bridge) loads on demand so the console bundle stays small.
const EditorLazy = lazy(() => import('./editor/Editor'));
export const SiteEditor = () => (
    <Suspense fallback={<div style={{ height: '100vh', display: 'grid', placeItems: 'center' }}><Spin /></div>}>
        <EditorLazy />
    </Suspense>
);
